<template>
  <div class="confirmation-summary-appointment">
    <ConfirmationSummaryRow v-if="companyName" label="Company:">
      <span>{{companyName}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow
      v-for="inspector in inspectors"
      :key="`inspector_${inspector.legacyId}`"
      label="Inspector:">
      <span>{{inspector.givenName}} {{inspector.familyName}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Date:">
      {{date(appointment)}}
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Time:">
      {{simpleTime(appointment)}}
    </ConfirmationSummaryRow>
  </div>
</template>

<script>
import { Mixins } from '@spectorasoftware/homegauge-vue';

import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';

const { DateTime } = Mixins;

export default {
  components: {
    ConfirmationSummaryRow,
  },
  props: {
    appointment: {
      type: String,
      required: true,
    },
    companyName: {
      type: String,
      default: '',
    },
    inspectors: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [DateTime],
};
</script>
